class CaseSelector extends HTMLElement {
  constructor() {
    super();
    this.productData = JSON.parse(
      this.querySelector("#body-pillow-cases-product-data").textContent
    );
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartCountBubble = document.querySelector("#cart-icon-bubble");
  }

  connectedCallback() {
    this.featuredImage = this.querySelector("#body-pillow-case-selector--img");
    this.priceContainer = this.querySelector(
      "#body-pillow-cases-selector--item-price"
    );
    this.bodyPillowCaseSelectorCta = this.querySelector(
      "#body-pillow-case-selector--cta"
    );
    this.selectedCase = this.querySelector(
      "#body-pillow-case-selector--selected-case"
    );
    this.dropdown = this.querySelector("#body-pillow-case-selector--dropdown");

    // If only one visible option, change the dropdown styling to a non-dropdown style and not clickable
    this.visibleOptions = this.dropdown.querySelectorAll(
      ".body-pillow-case-selector--dropdown--item"
    );
    if (this.visibleOptions.length <= 1) {
      this.bodyPillowCaseSelectorCta.classList.add("non-dropdown");
    }

    this.addToCartBtn = this.querySelector(
      "#body-pillow-cases-selector--item-atc"
    );

    this.selectedSize = this.querySelector(
      "#body-pillow-cases-carousel--selected-size-reference"
    );

    this.bodyPillowCaseSelectorCta.addEventListener(
      "click",
      this.toggleDropdown.bind(this)
    );

    this.addToCartBtn.addEventListener(
      "click",
      this.addToCartBtnEventHandler.bind(this)
    );
    this.addEventListener("input", this.inputEventHandler.bind(this));

    document.addEventListener(
      "PillowSize:change",
      this.pillowSizeChangeEventHandler.bind(this)
    );
  }

  disconnectedCallback() {
    this.bodyPillowCaseSelectorCta.removeEventListener(
      "click",
      this.toggleDropdown.bind(this)
    );

    this.addToCartBtn.removeEventListener(
      "click",
      this.addToCartBtnEventHandler.bind(this)
    );
    this.removeEventListener("input", this.inputEventHandler.bind(this));
    document.removeEventListener(
      "PillowSize:change",
      this.pillowSizeChangeEventHandler.bind(this)
    );
  }

  inputEventHandler(event) {
    const input = event.target;
    const value = input.value;
    this.loadCase(value);
    input.dataset.addedToCart === "true"
      ? this.setAddedToCartState(true)
      : this.setAddedToCartState();
  }

  loadCase(productHandle) {
    const data = this.productData.find(
      (el) => el.product_case_handle === productHandle
    );
    const {
      product_case_featured_image,
      custom_swatch_image,
      custom_swatch_title,
      variants,
    } = data;

    const variant = variants.find(
      (el) => el.handle === this.selectedSize.value
    );
    const { price, discounted_price, sale_percentage } = variant;

    this.featuredImage.setAttribute("src", product_case_featured_image);

    this.selectedCase
      .querySelector(".custom-swatch-image")
      .setAttribute("src", custom_swatch_image);

    this.selectedCase
      .querySelector(".custom-swatch-image")
      .setAttribute("srcset", custom_swatch_image);

    this.selectedCase.querySelector(".custom-swatch-title").innerHTML =
      custom_swatch_title;

    this.priceContainer.innerHTML = `
        <span>
            <b>${discounted_price}</b>
        </span>
        <span>
            <s>${price}</s>
        </span>
        <span><b>${sale_percentage}</b></span>
    `;

    this.toggleDropdown();
  }

  toggleDropdown() {
    if (this.visibleOptions.length <= 1) {
      return;
    }
    this.dropdown.classList.toggle("dawn-hidden");
  }

  pillowSizeChangeEventHandler(event) {
    const { size } = event.detail;
    this.checkForCasesBySize(size);
    this.selectedSize.value = size;
  }

  checkForCasesBySize(size) {
    this.dropdown
      .querySelectorAll(".body-pillow-case-selector--dropdown--item")
      .forEach((el) => {
        el.classList[
          el.dataset.availableSizes.includes(size) ? "remove" : "add"
        ]("dawn-hidden");
      });

    if (
      !this.dropdown
        .querySelector("input:checked")
        .dataset.availableSizes.includes(size)
    ) {
      const firstAvailableCaseHandle = this.dropdown.querySelector(
        ".body-pillow-case-selector--dropdown--item:not(.hidden) input"
      ).value;
      this.loadCase(firstAvailableCaseHandle);
      this.toggleDropdown();
    }
  }

  setAddedToCartState(flag = false) {
    if (flag) {
      this.addToCartBtn.innerHTML = `
      <img 
        src="https://cdn.shopify.com/s/files/1/0344/5689/5623/files/list-check-mark.svg"
        width="13"
        height="12"
        alt="Product Added">
      <span>ADDED</span>`;
      this.addToCartBtn.classList.add("added-to-cart");
      return;
    }
    this.addToCartBtn.innerHTML = `Add`;
    this.addToCartBtn.classList.remove("added-to-cart");
    this.addToCartBtn.disabled = false;
  }

  addToCartBtnEventHandler() {
    const selectedSize = this.selectedSize.value;
    const productHandle = this.dropdown.querySelector("input:checked").value;
    const product = this.productData.find(
      (el) => el.product_case_handle === productHandle
    );
    const variant = product.variants.find((el) => el.handle == selectedSize);

    const cartData = {
      items: [
        {
          id: variant.id,
          quantity: 1,
        },
      ],
    };
    this.addToCart(cartData);
    this.dropdown
      .querySelector("input:checked")
      .setAttribute("data-added-to-cart", true);
    this.setAddedToCartState(true);
  }

  async addToCart(cartData) {
    this.setLoadingToAddToCart(true);
    try {
      const addResponse = await fetch(
        window.Shopify.routes.root + "cart/add.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cartData),
        }
      );
      const data = await addResponse.json();
      if (!addResponse.ok) throw new Error(`${data.description}`);
      if (window._learnq) {
        window._learnq.push(["track", "Added to Cart", variant]);
      }
    } catch (error) {
      console.log(`${error}`);
    } finally {
      this.setLoadingToAddToCart(false);
      this.openAndPopulateCart();
    }
  }

  setLoadingToAddToCart(flag) {
    this.addToCartBtn.disabled = flag;
  }

  async openAndPopulateCart() {
    // Fetch the updated cart drawer content from the server
    const response = await fetch("/cart");
    const responseText = await response.text();

    // Parse the fetched HTML response into a DOM document
    const newCartMarkup = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    // Update cart icon bubble
    const newCartIconBubbleMarkup =
      newCartMarkup.querySelector("#cart-icon-bubble");
    this.cartCountBubble.innerHTML = newCartIconBubbleMarkup.innerHTML;

    // Remove empty class
    this.cartDrawer.classList.remove("is-empty");

    // Get new cart drawer markup
    const newCartDrawerMarkup = newCartMarkup.querySelector("#CartDrawer");

    // Replace markup
    this.cartDrawer
      .querySelector("#CartDrawer")
      .replaceWith(newCartDrawerMarkup);

    // Open cart
    this.cartDrawer.open();

    this.cartDrawer.hideInstallmentsCTA();
  }
}
customElements.define("body-pillow-case-selector", CaseSelector);
